import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUpdateAction } from "../../network/store/action/TaxResponseAction";
import {
  formUpdateData,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { updateMessage } from "../../redux/slice/toastSlice";

const AddUpdateForm = (props) => {
  // TO get Callbacks
  const dispatch = useDispatch();
  const formData = useSelector(formUpdateData);
  const itemInfo = formData.item;
  // // Page Form
  const [dataForm, setDataForm] = useState({
    name: "",
    cgst: "",
    sgst: "",
  });

  useEffect(() => {
    console.log("Item Info =>", itemInfo);
    if (itemInfo != undefined) {
      let updateValues = {
        name: itemInfo.name,
        cgst: itemInfo.cgst,
        sgst: itemInfo.sgst,
      };
      setDataForm(updateValues);
    }
  }, []);

  const handleInputChanges = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmtClick = async () => {
    let requestBody = {
      name: dataForm.name,
      cgst: dataForm.cgst,
      sgst: dataForm.sgst,
    };

    if (itemInfo != undefined) {
      requestBody.id = itemInfo.id;
    }

    await dispatch(createUpdateAction(requestBody)).then((response) => {
      if (response.status == true) {
        if (props.onSubmit) props.onSubmit();
      } else {
        dispatch(
          updateMessage({
            display: true,
            message: "Error While updating info",
          })
        );
      }
    });
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "100%",
          height: "100%",
          zIndex: "999",
          overflow: "scroll",
        }}
      >
        <div className="d-flex align-item-center justify-content-center">
          <div className="col-md-8">
            <div className="container">
              <div className="row mt-5">
                <div className="col-md-5 card-1 p-5">
                  {itemInfo != undefined ? (
                    <h4 className="text-center">Update Tax Slab</h4>
                  ) : (
                    <h4 className="text-center"> Add Tax Slab</h4>
                  )}

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Slab Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={dataForm.name}
                        onChange={(e) => handleInputChanges(e)}
                      />

                      <label>CGST</label>
                      <input
                        type="text"
                        name="cgst"
                        className="form-control"
                        value={dataForm.cgst}
                        onChange={(e) => handleInputChanges(e)}
                      />
                      <label>SGST</label>
                      <input
                        type="text"
                        name="sgst"
                        className="form-control"
                        value={dataForm.sgst}
                        onChange={(e) => handleInputChanges(e)}
                      />

                      <div
                        style={{
                          marginTop: 20,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{ display: "flex", justifyContent: "center" }}
                          type="button"
                          className="btn btn-purple-bg"
                          onClick={() => onSubmtClick()}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-white-bg"
                          onClick={() => {
                            dispatch(
                              updateFormInfo({
                                displayForm: false,
                                formData: {},
                              })
                            );
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpdateForm;
